import createSucursalForm from './createSucursalFormModel';
const {
  formField: {
    sucursal_name,
    sucursal_address,
    country,
    departament,
    municipaly,
    workplace,
    family_fund_compensation,
    landline,
    cell_phone,
    arl,
    associated_bank,
    type_account_bank,
    account_number,
    logo_sucursal,
  },
} = createSucursalForm;

export default {
  [sucursal_name.name]: '',
  [sucursal_address.name]: '',
  [country.name]: '',
  [departament.name]: '',
  [municipaly.name]: '',
  [workplace.name]: '',
  [family_fund_compensation.name]: '',
  [landline.name]: '',
  [cell_phone.name]: '',
  [arl.name]: '',
  [associated_bank.name]: '',
  [type_account_bank.name]: '',
  [account_number.name]: '',
  [logo_sucursal.name]: null,
};
